import * as React from 'react';

/* v2 icon set — 20×20, 1.7px stroke, round caps (see docs/design-system). */

const base = {
    width: 19,
    height: 19,
    viewBox: '0 0 20 20',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.7,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
};

export const IconHome = () => (
    <svg {...base}>
        <path d="M3.5 9.5 10 3.5l6.5 6v6.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1z" />
        <path d="M8 17v-5h4v5" />
    </svg>
);

export const IconJobs = () => (
    <svg {...base}>
        <rect x="3" y="6.5" width="14" height="9.5" rx="2" />
        <path d="M7 6.5V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1.5M3 10.5h14" />
    </svg>
);

export const IconActivations = () => (
    <svg {...base}>
        <rect x="3" y="4" width="14" height="13" rx="2" />
        <path d="M3 8h14M7 2.5V5M13 2.5V5" />
    </svg>
);

export const IconDevices = () => (
    <svg {...base}>
        <rect x="5.5" y="2.5" width="9" height="15" rx="2" />
        <path d="M8.5 15.5h3" />
    </svg>
);

export const IconOverview = () => (
    <svg {...base}>
        <rect x="3" y="3" width="5.5" height="5.5" rx="1.5" />
        <rect x="11.5" y="3" width="5.5" height="5.5" rx="1.5" />
        <rect x="3" y="11.5" width="5.5" height="5.5" rx="1.5" />
        <rect x="11.5" y="11.5" width="5.5" height="5.5" rx="1.5" />
    </svg>
);

export const IconGallery = () => (
    <svg {...base}>
        <rect x="3" y="4.5" width="14" height="11" rx="2" />
        <circle cx="7.3" cy="8.6" r="1.3" />
        <path d="M4 14.5 8.5 10l2.5 2.5L14 9.5l3 3" />
    </svg>
);

export const IconCapture = () => (
    <svg {...base}>
        <path d="M3.5 7.5h2.4l1.2-1.7h5.8l1.2 1.7h2.4a1 1 0 0 1 1 1v6.3a1 1 0 0 1-1 1H3.5a1 1 0 0 1-1-1V8.5a1 1 0 0 1 1-1Z" />
        <circle cx="10" cy="11.3" r="2.7" />
    </svg>
);

export const IconMedia = () => (
    <svg {...base}>
        <path d="M10 3 17 7l-7 4-7-4 7-4Z" />
        <path d="M3 11l7 4 7-4" />
    </svg>
);

export const IconShare = () => (
    <svg {...base}>
        <path d="M17.5 3 9 11.5M17.5 3 12 17l-3-5.5L3.5 8.5 17.5 3Z" />
    </svg>
);

export const IconPlus = () => (
    <svg {...base}>
        <path d="M10 4.5v11M4.5 10h11" />
    </svg>
);

export const IconProcessing = () => (
    <svg {...base}>
        <path d="M5 3.5v4.7M5 11.8v4.7M10 3.5v2.2M10 9.3v7.2M15 3.5v7.7M15 14.8v1.7" />
        <circle cx="5" cy="10" r="1.7" />
        <circle cx="10" cy="7.5" r="1.7" />
        <circle cx="15" cy="13" r="1.7" />
    </svg>
);

export const IconMore = () => (
    <svg {...base} fill="currentColor" stroke="none">
        <circle cx="5" cy="10" r="1.3" />
        <circle cx="10" cy="10" r="1.3" />
        <circle cx="15" cy="10" r="1.3" />
    </svg>
);

export const IconLive = () => (
    <svg {...base}>
        <circle cx="10" cy="10" r="7" />
        <path d="M3 10h14M10 3a11 11 0 0 1 0 14 11 11 0 0 1 0-14" />
    </svg>
);

/* Production section (ops merge) */

export const IconProduction = () => (
    <svg {...base}>
        <path d="M4 16.5v-2.2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2.2" />
        <circle cx="10" cy="6.2" r="3" />
        <path d="m14.8 10.2 1.2 1.2 2-2.2" />
    </svg>
);

export const IconPipeline = () => (
    <svg {...base}>
        <path d="M3.5 5h13M3.5 10h13M3.5 15h8" />
        <circle cx="15.5" cy="15" r="1.6" />
    </svg>
);

export const IconStaff = () => (
    <svg {...base}>
        <circle cx="7.5" cy="6.8" r="2.6" />
        <path d="M2.8 16.5v-1a4 4 0 0 1 4-4h1.4a4 4 0 0 1 4 4v1" />
        <circle cx="14.2" cy="7.6" r="2.1" />
        <path d="M14.5 11.7a3.5 3.5 0 0 1 2.9 3.4v1.4" />
    </svg>
);

export const IconGear = () => (
    <svg {...base}>
        <path d="M10 2.8 16.5 6.4v7.2L10 17.2 3.5 13.6V6.4L10 2.8Z" />
        <path d="M3.5 6.4 10 10l6.5-3.6M10 10v7.2" />
    </svg>
);

export const IconDesign = () => (
    <svg {...base}>
        <path d="M10 3a7 7 0 1 0 0 14c1.2 0 1.8-.7 1.8-1.5 0-1.2-1-1.4-1-2.5 0-.9.7-1.5 1.7-1.5H14a3.3 3.3 0 0 0 3-3.3C17 5.2 13.9 3 10 3Z" />
        <circle cx="6.8" cy="8" r="1" />
        <circle cx="10" cy="6.2" r="1" />
        <circle cx="13.2" cy="8" r="1" />
    </svg>
);

export const IconVenues = () => (
    <svg {...base}>
        <path d="M10 17.5s5.5-5 5.5-9a5.5 5.5 0 1 0-11 0c0 4 5.5 9 5.5 9Z" />
        <circle cx="10" cy="8.3" r="2" />
    </svg>
);

export const IconContacts = () => (
    <svg {...base}>
        <rect x="3" y="3.5" width="14" height="13" rx="2" />
        <circle cx="8" cy="8.4" r="1.9" />
        <path d="M4.8 14.5a3.4 3.4 0 0 1 6.4 0M13.5 7.5h1.7M13.5 10.5h1.7" />
    </svg>
);

export const IconSettings = () => (
    <svg {...base}>
        <path d="M4 6.5h8M15.5 6.5h.5M4 13.5h.5M8 13.5h8" />
        <circle cx="13.5" cy="6.5" r="1.8" />
        <circle cx="6.2" cy="13.5" r="1.8" />
    </svg>
);

export const IconBack = () => (
    <svg {...base}>
        <path d="M12 4.5 6.5 10l5.5 5.5" />
    </svg>
);
